// extracted by mini-css-extract-plugin
module.exports = {"externalLink":"ExternalLink_externalLink__YzBDW"};